<template>
  <BaseCheckbox v-model="checked" :validate="{}" class="filter-checkbox">
    <span class="filter-checkbox__title">
      <slot />
    </span>
  </BaseCheckbox>
</template>

<script setup>
import BaseCheckbox from "~/modules/shared/inputs/BaseCheckbox.vue";
import { useProductFilterStore } from "~/store/productFilter.store.js";

const props = defineProps({
  label: { type: String, required: true },
});

const { addLabel, removeLabel } = useProductFilterStore();

const checked = computed({
  get() {
    return useProductFilterStore().params.labels.includes(props.label);
  },
  set(isChecked) {
    isChecked ? addLabel(props.label) : removeLabel(props.label);
  },
});
</script>
